(window.URL = "https://shark-app-hwull-vatwr.ondigitalocean.app/"),

$(document).ready(function () {
        var stateLocations = [
          {
            "name": "Alabama",
            "value": "AL"
          },
          {
            "name": "Alaska",
            "value": "AK"
          },
          {
            "name": "American Samoa",
            "value": "AS"
          },
          {
            "name": "Arizona",
            "value": "AZ"
          }, {
            "name": "Arkansas",
            "value": "AR"
          }, {
            "name": "California",
            "value": "CA"
          }, {
            "name": "Colorado",
            "value": "CO"
          }, {
            "name": "Connecticut",
            "value": "CT"
          }, {
            "name": "Delaware",
            "value": "DE"
          }, {
            "name": "District Of Columbia",
            "value": "DC"
          }, {
            "name": "Federated States Of Micronesia",
            "value": "FM"
          }, {
            "name": "Florida",
            "value": "FL"
          }, {
            "name": "Georgia",
            "value": "GA"
          }, {
            "name": "Guam",
            "value": "GU"
          }, {
            "name": "Hawaii",
            "value": "HI"
          }, {
            "name": "Idaho",
            "value": "ID"
          }, {
            "name": "Illinois",
            "value": "IL"
          }, {
            "name": "Indiana",
            "value": "IN"
          }, {
            "name": "Iowa",
            "value": "IA"
          }, {
            "name": "Kansas",
            "value": "KS"
          }, {
            "name": "Kentucky",
            "value": "KY"
          }, {
            "name": "Louisiana",
            "value": "LA"
          }, {
            "name": "Maine",
            "value": "ME"
          }, {
            "name": "Marshall Islands",
            "value": "MH"
          }, {
            "name": "Maryland",
            "value": "MD"
          }, {
            "name": "Massachusetts",
            "value": "MA"
          }, {
            "name": "Michigan",
            "value": "MI"
          }, {
            "name": "Minnesota",
            "value": "MN"
          }, {
            "name": "Mississippi",
            "value": "MS"
          }, {
            "name": "Missouri",
            "value": "MO"
          }, {
            "name": "Montana",
            "value": "MT"
          }, {
            "name": "Nebraska",
            "value": "NE"
          }, {
            "name": "Nevada",
            "value": "NV"
          }, {
            "name": "New Hampshire",
            "value": "NH"
          }, {
            "name": "New Jersey",
            "value": "NJ"
          }, {
            "name": "New Mexico",
            "value": "NM"
          }, {
            "name": "New York",
            "value": "NY"
          }, {
            "name": "North Carolina",
            "value": "NC"
          }, {
            "name": "North Dakota",
            "value": "ND"
          }, {
            "name": "Northern Mariana Islands",
            "value": "MP"
          }, {
            "name": "Ohio",
            "value": "OH"
          }, {
            "name": "Oklahoma",
            "value": "OK"
          }, {
            "name": "Oregon",
            "value": "OR"
          }, {
            "name": "Palau",
            "value": "PW"
          }, {
            "name": "Pennsylvania",
            "value": "PA"
          }, {
            "name": "Puerto Rico",
            "value": "PR"
          }, {
            "name": "Rhode Island",
            "value": "RI"
          }, {
            "name": "South Carolina",
            "value": "SC"
          }, {
            "name": "South Dakota",
            "value": "SD"
          }, {
            "name": "Tennessee",
            "value": "TN"
          }, {
            "name": "Texas",
            "value": "TX"
          }, {
            "name": "Utah",
            "value": "UT"
          }, {
            "name": "Vermont",
            "value": "VT"
          }, {
            "name": "Virgin Islands",
            "value": "VI"
          }, {
            "name": "Virginia",
            "value": "VA"
          }, {
            "name": "Washington",
            "value": "WA"
          }, {
            "name": "West Virginia",
            "value": "WV"
          }, {
            "name": "Wisconsin",
            "value": "WI"
          }, {
            "name": "Wyoming",
            "value": "WY"
          }
        ]



        $selectState= $("#selectState");
        $selectRequestState = $("#selectRequestState");
        $filteredResult= $("#filteredResult");
        $selectHostState = $(".selectHostState");
        
        var mapLocation = [];
        var allCourses = [];
        var startDate ;
        var filteredArray = [];
        var endDate ;
        var discountDetails = [];
        var states;
        var startRequestDateRange;
        var allClasses ; 

        init();

        async function init() {
            await getCourseDiscountDetails();
            await getOfferProductDetails();
            await getAllCourseDetails();
            render();
            courseFinderMap(mapLocation);
            await getStates();
          
        }


        // Define a function that generates an HTML select element and populates it with options from a `stateLocations` array
        function render() {
            var content = "";
            var content = "<option value='' >Select State</option>"
            var content2 = "<option value='' >Select State</option>"
            for (let i = 0; i < stateLocations.length; i++) {
                  content += '<option value="' + stateLocations[i].value + '">' + stateLocations[i].name + '</option>'
                  content2 += '<option value="' + stateLocations[i].name  + '">' + stateLocations[i].name + '</option>'
            }
            // Set the inner HTML of the `#selectState` element to the generated HTML
            $selectState.html(content);
            $selectRequestState.html(content2);
            $selectHostState.html(content2);
        }

        async function getOfferProductDetails() {
          // Set the settings object with the URL and method for the request

          var settings = {
            "url": window.URL+ "api/products/specialoffer/all",
            "method": "GET",
            "timeout": 0
          };
          // Use the jQuery ajax method to make the HTTP GET request
          $.ajax(settings).done(function (response) {
            offerProducts = response.res ;
          });
        }


    
//Filter section

        // Select the `#btnSend` element using jQuery and add an event listener for the "click" event
        var btnSend = $("#btnSend")
        btnSend.on("click",async function(e){
          e.preventDefault();
          // Call the `courseFilterDetails()` function when the button is clicked
          await courseFilterDetails();
        })

        // This is an asynchronous function that retrieves all the course details from an API endpoint
        async function getAllCourseDetails() {
          // Set the settings object with the URL and method for the request

          var settings = {
            "url": window.URL+ "api/collection/courses/all",
            "method": "GET",
            "timeout": 0
          };
          // Use the jQuery ajax method to make the HTTP GET request
          $.ajax(settings).done(function (response) {
            allCourses = response.res ;// Assign the response array data object to the 'allCourses' variable
              if(response.success){
                courseFilterDetails()
                .then(function(filteredArray) {
                  // Use the filteredArray here
                 allClasses = filteredArray ; 
                })
                .catch(function(error) {
                  // Handle the error here
                  console.error(error);
                });
                
              }
          });
        }

        //Date Range Picker
     
        $('input[name="datefilter"]').daterangepicker({
          autoApply : true
        }, function(start, end, label) {
          startDate = start.format('YYYY-MM-DD');
          endDate = end.format('YYYY-MM-DD'); 
        });
        function courseFilterDetails() {
          return new Promise(function(resolve, reject) {
            // Define AJAX settings for the POST request
            var settings = {
              "url":window.URL+  "api/course/filter",
              "method": "POST",
              "timeout": 0,
              "headers": {
                "Content-Type": "application/json"
              },
              "data": JSON.stringify({
                "selectedState":$("#selectState").val(),
                "selectedCourse": $("#selectClass").val(),
                "location":$("#city").val(),
                "zipCode":$("#zipCode").val(),
                "startDate":startDate,
                "endDate":endDate
              }),
            };
        
            // Send the POST request using jQuery's `ajax()` method
            $.ajax(settings)
              .done(function(response) {
                var currentDate = new Date();
                filteredResult = response.res.filter(function(item) {
                  // Convert the classdate to a Date object
                  var classDate = new Date(item.startDate);
                  // Check if the classdate is greater than or equal to the current date
                  return classDate >= currentDate;
                });
                filteredArray = sortByKey(filteredResult, $("#sorting").val() )
                resultSection(filteredArray);
                resolve(filteredArray); // Resolve the Promise with the filteredArray
              })
              .fail(function(error) {
                reject(error); // Reject the Promise with the error
              });
          });
        }
        
          // Sort the fillter result with date , promotions 
          var slectItem = $("#sorting")
           slectItem.on("change",async function(e){
             e.preventDefault(); 
              sortDateResult = sortByKey(filteredArray, $(this).val());
              await  resultSection(sortDateResult);
           
           })

          function sortByKey(array, key) {
            if(key == 'hasOffers'){
              return array.sort(function(a, b) {
                if (a.hasOffers && !b.hasOffers) {
                  return -1; // "has" attribute comes before no attribute
                } else if (!a.hasOffers && b.hasOffers) {
                  return 1; // "has" attribute comes after no attribute
                } else {
                  return 0; // Maintain the original order if both have or don't have the attribute
                }
              });
            } else {
              return array.sort(function(a, b) {
                var x = a[key];
                var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
              });
            }
           
          }

        // Usage of the courseFilterDetails() function
      
          async function resultSection(resultArray){
          
            mapLocation = [];
            var content = "";
            content += '<p class="xs text-muted m-b-10 filter-wrap">Showing results for ' + resultArray.length + ' courses</p>'
            // This part is running when the filter result is empty
            if(resultArray.length == 0){
              resultArray = allClasses.slice(0, 20);
                content +='<div class="empty-result">'
                content += '<div class="row justify-content-center align-items-center ">'
                content += '<div class="col-md-6 d-flex flex-column justify-content-center align-items-center">'
                content += '<h6 class="text-primary m-b-30 text-center">Don’t see a date that works for you?</h6>'
                content += '  <button class="btn btn-primary" tabindex="0" data-bs-toggle="modal" role="button" data-bs-target="#infoModal">Request a class</button>'
                content +='</div></div></div>'
                content +='<p class="m-t-10 m-b-30 fs-12 text-uppercase">Other available classes</p>'
              }
              content += '<div class="result-section">'
            for(var i=0; i < resultArray.length ; i++){

                const date = new Date(resultArray[i].startDate);
                const month = date.toLocaleString('default', { month: 'short' });
                const dayOfMonth = date.getDate();
                const dayName = date.toLocaleString('default', { weekday: 'short' });

                content += ' <div   class="resultCard course-'+ resultArray[i].courseId +'">'

                if(resultArray[i]?.hasOffers){
                  
                  content += '<div class="special-promo d-flex align-items-center justify-content-between">'
                  if(resultArray[i].productOffers.length > 1){
                  content += '  SPECIAL OFFER | 2 free gift items'
                  } else {
                    content += '  SPECIAL OFFER | A free gift item'
                  }
                  content += '<div class="specialPromoIcon" id="specialPromoIcon" data-index="' + i + '"><i class="bi bi-info-circle"   ></i></div>';
                  content += ' </div>'
                } 
                var obj = {
                  pointAddress: resultArray[i].address,
                  hasOffer :(resultArray[i].hasOwnProperty('hasOffers')) ? resultArray[i].hasOffers : false ,
                  openInfo:false,
                  pointerContent : ''
                
                };
                mapLocation.push(obj);
                for ( var j=0 ; j < allCourses.length ;j++){
                  if( allCourses[j].id == resultArray[i].courseId){
                    content += ' <div class="p-b-15 gotoEnrollment gotoEnrollment'+ i +'" id="gotoEnrollment" data-index="' + i + '" data-toggle="course" tabindex="0" role="button" data-target="' + allCourses[j].handle+ '"  >'
                    content += '<div class="row course-detail-card">'
                    content += '  <div class="padding-15 col-md-8 d-flex flex-column">'
                    
                    content += '   <div class="d-flex justify-content-between m-b-30">'
                    content += '    <div class="d-flex flex-column m-r-20">'
                    content += '       <p class="course-title m-b-5">' + allCourses[j].title + '</p>'
                    content += '       <p class="sm text-opac-50">' + resultArray[i].noOfDays + ' Day Course</p>'
                    content += '     </div>'
                    content += '     <div class="d-flex flex-column">'
                    content += '       <p class="mono-sm fs-18">$' + allCourses[j].variants[0].price + '</p>'
                    content += '     </div>'
                    content += '   </div>'
                      
                    content += '   <div class="d-flex course-Date">'
                    content += '     <div class=" d-flex flex-column m-r-30">'
                    content += '       <p class="dateName fs-11 overline m-b-5">'+ month + '</p>'
                    content += '        <p class="day m-b-0">'+ dayOfMonth +'</p>'
                    content += '      </div>'
                    content += '     <div class="line"></div>'
                    content += '     <div class=" d-flex flex-column m-l-10">'
                    content += '        <p class="dateName text-opac-60 m-b-5">'+ dayName +'</p>'
                    content += '      <p class="fs-13 m-b-0">' + resultArray[i].startTime + '</p>'
                    content += '     </div>'
                    content += '    </div>'
                    content += '  </div>'
                if(resultArray[i].locationImage){
                    content += '  <div class="locationImage col-md-4 d-flex flex-column justify-content-end" style="background-image: url('+ resultArray[i].locationImage +');">'
                    var formattedAddress = resultArray[i].address.split("\n")
                    for (const line of formattedAddress) {
                      content += '    <p class="text-white fs-13 m-b-0">' + line + '</p>'
                    }
                    if(resultArray[i].available < 4 && resultArray[i].available > 0 ){
                      content += '    <span class="slot-badge m-t-10">Only ' + resultArray[i].available + ' Spot Available</span>'
                    }
                    if(resultArray[i].available == 0){
                      content += '    <span class="slot-badge m-t-10">SOLD OUT</span>'
                    }
                    content += '  </div>'
                } else {
                    content += '  <div class="locationImage col-md-4 d-flex flex-column justify-content-end" style="background-image: url(https://cdn.shopify.com/s/files/1/0696/7427/1009/files/180313182911-01-las-vegas-travel-strip.jpg?v=1686826389);">'
                    content += '    <p class="text-white fs-13 m-b-0">' + resultArray[i].address + '</p>'
                    if(resultArray[i].available < 4 && resultArray[i].available > 0){
                      content += '    <span class="slot-badge m-t-10">Only ' + resultArray[i].available + ' Spot Available</span>'
                    }
                    if(resultArray[i].available == 0){
                      content += '    <span class="slot-badge m-t-10">SOLD OUT</span>'
                    }
                    content += '  </div>'
                }
                    content += '</div>'
                    content += ' <div class="d-flex justify-content-center loadingSpinner d-none loadingSpinner'+ i +'"" id="loadingSpinner" >'
                    content += ' <div class="loading-overlay__spinner">'
                    content += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" fill="none" viewBox="0 0 66 66">'
                    content += '    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>'
                    content += ' </svg>'
                    content += ' </div>'
                    content += ' </div>'
                    content += '</div>'
                    content += '</div>'
                }    
              }

              
              }
              
              content += '</div>'
              await courseFinderMap(mapLocation);// Call the `courseFinderMap()` function
              $filteredResult.html(content); 
          
             // Go to the enrollment process when clicking the course card
              $filteredResult.on('click', '#gotoEnrollment', async function() {
                  
                  var userId = __st.cid;
                  var index = $(this).data('index'); // Get the index value
                  var datas = resultArray[index];
                  
                  
                  var dataString = JSON.stringify(datas); // Get the data using the index
                  localStorage.setItem('selectedData',dataString);
                  
                  var a = $(this).attr("data-target");
                  $.getJSON(
                    window.Shopify.routes.root + "products/" + a + ".js",
                    function (o) {
                       localStorage.setItem("current-course", JSON.stringify(o))
                        var lc = JSON.parse(localStorage.getItem("current-course"));
                        if (!userId) {
                          window.location.href =
                            location.protocol +
                            "//" +
                            location.host +
                            window.Shopify.routes.root +
                            "/account/login";
                        } else {
                          addToCart(index ,lc);
                        }
                    }
                  );

                  
                  
                
                 
                
                 function addToCart (index ,lc ) {
                  $(".loadingSpinner"+index).attr("style", "display: flex !important");
                  $(".gotoEnrollment"+index).attr("style", "opacity: 0.5 !important");
                   
                    let formData = {
                      'items': [{
                       'id':lc.variants[0].id,
                       'quantity': 1
                       }]
                     };
                    fetch(window.Shopify.routes.root + "cart/add.js", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(formData),
                     
                    })
                      .then((response) => {
                        if (response.status == 200) {
                          getCartToken(lc);
                        } else {
                          console.log("Error Adding to cart");
                        }
                        
                        return response.json();
                      })
                      .catch((error) => {
                        console.error("Error:", error);
                      });
                      
                    }
                   function getCartToken (lc) {
                    var settings = {
                      url: window.Shopify.routes.root + "cart.js",
                      method: "GET",
                      timeout: 0,
                    };
                    
                    $.ajax(settings).done(function (response) {
                      if (response) {
                        postEnrollmentData(response ,lc);
                      }
                    });
                  }
                  
                  function postEnrollmentData  (data ,lc) {
                    
                    data = JSON.parse(data);
                    var selectedLocationLabel ='';
                    for (let i = 0; i < stateLocations.length; i++) {
                      if(stateLocations[i].value == datas.state){
                        selectedLocationLabel = stateLocations[i].name
                      }
                    }
                    var val = [{
                      attribute:"pick-date",
                      value: {
                        selectedDate: datas.startDate,
                        selectedLocationLabel:selectedLocationLabel,
                        courseTier: "first",
                        course:{
                          title :lc.title,
                        },
                        value :{
                          address:datas.address,
                          startTime:datas.startTime,
                          startDate:datas.startDate,
                          location: datas.location,

                        }
                      }
                    }]
                    var url =  window.URL + "api/enrollment/create";
                    var data = {
                      token: data.token,
                      userId: userId,
                      enrollmentData: val,
                      classInfo: lc,
                    };
                    
                    fetch(url, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(data),
                    })
                      .then((response) => {
                        if (response) {
                          window.location.href =
                            location.protocol +
                            "//" +
                            location.host +
                            window.Shopify.routes.root +
                            "/cart";
                        }
                      })
                      .catch((error) => {
                        console.error("Error:", error);
                      });
                  }
                });
          
                // Change map location when hover the course details cards
                $('.gotoEnrollment').hover( function(e) {
                
                var index = $(this).data('index'); 
                var makerContent = "";
          
                makerContent += '<div class="pointer-popup ">'
                if(resultArray[index]?.locationImage){
                  makerContent += '<img class="location-image" src="'+ resultArray[index].locationImage + '" alt="pointer image" > '
                } else {
                  makerContent += '<img class="location-image" src="https://cdn.shopify.com/s/files/1/0696/7427/1009/files/180313182911-01-las-vegas-travel-strip.jpg?v=1686826389" alt="pointer image" > '
                }
                if(resultArray[index]?.hasOffers){
                  makerContent += '<span class="promo-logo d-flex align-items-center"><i class="bi bi-star-fill"></i> SPECIAL</span>'
                }
                let reg =[];
                if (states.length > 0)
                {
                  for (var i = 0; i < states.length; i++) {
                    if (resultArray[index].state == states[i]["state"]) {
                    states[i]["esthetician"] ? reg.push("Esthetician license") : null ;
                    states[i]["medical"] ? reg.push("Medical license") : null;
                    states[i]["other"] ? reg.push(states[i]["other"]) : null;
                    states[i]["cosmetologist"] ? reg.push("Cosmetologist license") : null ;
                  }
                }
                }
                
                if(reg.length > 0 ){
                makerContent += '<img class="licence-logo" src="https://cdn.shopify.com/s/files/1/0696/7427/1009/files/Circle_10_1_e346fa3d-a9fe-4337-bfc8-f8e0a8497d48.png?v=1685961297">'
                makerContent += '<p class="text-muted fs-12 m-t-30 m-l-10 text-uppercase">License Required</p>'
                makerContent += '<p class="fs-16 text-primary m-l-10">'
                  for(var i=0 ; i <reg.length;i++){
                    makerContent += reg[i]+', '
                  }

                makerContent += '</p>'
                makerContent += '</div>'
                }
                var request = {
                  query: resultArray[index].address,
                  fields: ['name', 'geometry']
                };
                const data = {
                  place: '',
                  offerHas : (resultArray[index].hasOwnProperty('hasOffers')) ? resultArray[index].hasOffers : false ,
                  openInfo : true,
                  contentString : makerContent
                }
              
                findGeometryLocation(request , data );
                // await courseFinderMap(hoverLocation);
              },
              function(e) {
                var index = $(this).data('index'); 
                var request = {
                  query: resultArray[index].address,
                  fields: ['name', 'geometry']
                };
                const data = {
                  place: '',
                  offerHas : (resultArray[index].hasOwnProperty('hasOffers')) ? resultArray[index].hasOffers : false ,
                  openInfo : false,
                  contentString : ''
                }
                findGeometryLocation(request , data );

              });

             //Popover with specail promotion details
             $('.specialPromoIcon').hover( function(e) {
                
              var $icon = $(this);
              var index = $(this).data('index');
                var popoverContent = '';
                popoverContent += ' <div class="special-promo-card"> '
                popoverContent += ' <div class="card-content">'
                popoverContent += ' <div class="gift-badge d-flex"><i class="bi bi-gift m-r-10 text-white"></i>'
                if(resultArray[index].productOffers.length > 2){ 

                  popoverContent += ' <p class="text-white m-b-0">2 Free gift items</p></div>'
                  popoverContent += '<p class="text-muted text-left">Hurry, this limited-time promotion won’t last forever.</p>'
                  popoverContent +='<div class="d-flex"><div class="gift-card d-flex flex-column m-r-10">'
                  popoverContent += '<img src="'+ resultArray[index].productOffers[0].image +'" alt="Card Image" class="card-image"> '
                  popoverContent += ' <p class="text-opac-87">' + resultArray[index].productOffers[0].label + '</p>'
                  popoverContent += '</div><div class="gift-card d-flex flex-column">'
                  popoverContent += '<img src="'+ resultArray[index].productOffers[1].image +'" alt="Card Image" class="card-image"> '
                  popoverContent += ' <p class="text-opac-87 p-l-5">' + resultArray[index].productOffers[1].label + '</p>'
                  popoverContent +=' </div> </div>'
                } else {
                  popoverContent += ' <p class="text-white m-b-0">Free gift item</p></div>'
                  popoverContent += '<p class="text-muted text-left">Hurry, this limited-time promotion won’t last forever.</p>'
                  popoverContent += '<img src="'+ resultArray[index].productOffers[0].image +'" alt="Card Image" class="card-image"> '
                  popoverContent += ' <p class="text-opac-87 p-l-5 text-left">' + resultArray[index].productOffers[0].label + '</p>'
                  popoverContent += '<div class="describe-promoproduct"> <p class="text-left fs-12 text-opac-45 m-b-0">' + resultArray[index].productOffers[0].discription + '</p></div>'
                }
                popoverContent += ' </div>'
                popoverContent += ' </div>'

              $icon.tooltip({
                template: '<div class="tooltip special-promo-tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
                title: popoverContent,
                placement: 'top',
                trigger: 'hover',
                html: true
              }).tooltip('show');
            },
            function(e) {
              var $icon = $(this);
            
              $icon.tooltip('dispose');
            });


          }
        var map;
        var service;
        let marker = []; 
        // Define the myMap function
        async function courseFinderMap(locations) {
          // Define the properties of the map, such as zoom level and controls
          
          var mapProp = {
            zoom: 4,
            fullscreenControl: false,
            zoomControl: false,
            scaleControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: true,
            styles
      
          };
          map = new google.maps.Map(document.getElementById("courseScheduleMap"), mapProp);
          // Loop through each location in the locations array
          for (i = 0; i < locations.length; i ++) {
            var request = {
              query: locations[i].pointAddress,
              fields: ['name', 'geometry']
            };
            const data = {
              place: '',
              offerHas : locations[i]?.hasOffer,
              openInfo : locations[i]?.openInfo,
              contentString : locations[i]?.pointerContent
            }
           
              service = new google.maps.places.PlacesService(map);
              await findGeometryLocation(request , data );
            }
         
          }

          async function findGeometryLocation(request ,data){
            await service.findPlaceFromQuery(request, async function(results, status) {
              
              if (status === google
                  .maps
                  .places
                  .PlacesServiceStatus
                  .OK) {
                for (var j = 0; j < results.length; j++) {
                    data.place = results[j]; 
                    await createPointMarker(data);
                }                                                               
                await map.panTo(results[0].geometry.location);
              }
            });
          }

          var infowindow = null;
           // Define the createMarker function that takes a place object as a parameter
           async function createPointMarker(data) {
           
            // let marker = []; 
                 await getMarkerImage(data)
                 .then((symbole) => {
                   marker = new google.maps.Marker({
                     position: data.place.geometry.location,
                     map: map,
                     icon: symbole,
                   });
                 })
                 
                 if (!infowindow) {
                  infowindow = new google.maps.InfoWindow();
                }
              
                infowindow.setContent(data.contentString);
              
                if (data.openInfo) {
                    infowindow.open({
                      anchor: marker,
                      map,
                    });
                } 
                else {
                  infowindow.close();
                }
               }
        

          // Change the pointer icon according to specail promotion has or not
          function getMarkerImage(data) {
            return new Promise((resolve, reject) => {
              let ico;
              if (data.offerHas) {
                ico = new google.maps.MarkerImage(
                  "https://cdn.shopify.com/s/files/1/0696/7427/1009/files/pin_point_special.png?v=1684828838"
                );
              } else {
                ico = new google.maps.MarkerImage(
                  "https://cdn.shopify.com/s/files/1/0696/7427/1009/files/pin_point.png?v=1684828831"
                );
              }
              resolve(ico);
              
            });
          }
      

        

//Request a class section

        // Select the `#requestClassSubmitBtn` element using jQuery and add an event listener for the "click" event
        
          // $('#suggestCourse').validate();
          var $suggestCourse  = $('#suggestCourse');
          var requestModal = $('#infoModal');
          var requestClassSubmitBtn= $("#requestClassSubmitBtn")
          requestClassSubmitBtn.on("click",function(e){
            e.preventDefault();
            if($suggestCourse.valid()){
              requestaClass();
            }else{
              $([document.documentElement, document.body]).animate({
                scrollTop: $($(".error")[0]).offset().top - 100
            }, 500);
            }
            
          })

            //Date Range Picker
          $('input[name="requestDateRange"]').daterangepicker({
            autoApply : true
          }, function(start, end, label) {
            startRequestDateRange = start.format('YYYY-MM-DD')+ ' - ' + end.format('YYYY-MM-DD');
          });
  

          // request a class 
          async function requestaClass() {
           

            var settings = {
              "url": window.URL+ "api/requestClass/create",
              "method": "POST",
              "timeout": 0,
              "headers": {
                "Content-Type": "application/json"
              },
              "data": JSON.stringify({
                "requestedState":$("#selectRequestState").val(),
                "requestedCourseName": $("#selectRequestClassName").val(),
                "requestedCourseType": $("#selectRequestCourseType").val(),
                "city":$("#requestCity").val(),
                "zipcode":$("#requestZipCode").val(),
                "country":$("#selectRequestCountry").val(),
                "dateRange":startRequestDateRange
              }),
            };
   
            $.ajax(settings).done(function (response) {
              if (response) {
                requestModal.modal('hide');
                $("#done").addClass("d-flex");
                $("#done").removeClass("d-none");
                window.scrollTo();
               alert ("Successfully Submited");
                }
            });
          }
      


              // host a class 
              // $('#hostClass').validate();
              var $hostClass = $('#hostClass');
              var hostModal = $('#hostClassModal');
              var hostClassSubmitBtn = $("#hostClassSubmitBtn")
              hostClassSubmitBtn.on("click",function(e){
                e.preventDefault();
                if($hostClass.valid()){
                  hostaClass();
                }else{
                  $([document.documentElement, document.body]).animate({
                    scrollTop: $($(".error")[0]).offset().top - 100
                }, 500);
                }
                
              })

              async function hostaClass() {
    
                var settings = {
                  "url": window.URL+ "api/hostClass/create",
                  "method": "POST",
                  "timeout": 0,
                  "headers": {
                    "Content-Type": "application/json"
                  },
                  "data": JSON.stringify({
                    "fullName":$("#fullName").val(),
                    "email": $("#emailAddress").val(),
                    "teleNumber": $("#phoneNumber").val(),
                    "businessName":$("#businessName").val(),
                    "address":$("#hostAddress").val(),
                    "zipcode":$("#hostZipCode").val(),
                    "city":$("#hostCity").val(),
                     "bestReach":$("#bestReach").val(),
                     "website":$("#website").val(),
                     "socialMedia":$("#socialMedia").val(),
                     "airport":$("#airport").val(),
                     "state":$("#hostState").val(),
                  }),
                };
       
                $.ajax(settings).done(function (response) {
                  if (response) {
                  alert ("Successfully Submited");
                  hostModal.modal('hide');
                  $("#done").addClass("d-flex");
                  $("#done").removeClass("d-none");
                  window.scrollTo();
                  }
                });
              }


              // Get discount details
              async function getCourseDiscountDetails() {
                // Set the settings object with the URL and method for the request
                var settings = {
                  "url": window.URL+ "api/discount/course/details",
                  "method": "GET",
                  "timeout": 0
                };
                // Use the jQuery ajax method to make the HTTP GET request
                $.ajax(settings).done(function (response) {
                  discountDetails = response.res;
                });
              }

              // Get state requlations details
              async function getStates() {
                return new Promise((resolve) => {
                  var settings = {
                    url: window.URL+ "api/stateRegulations/all",
                    method: "GET",
                    timeout: 0,
                    "Content-Type": "application/json",
                  };
            
                  $.ajax(settings).done(function (response) {
                    if (response) {
                       states = response.res;

                    }
                  });
                });
              }
            
});
    

 